import { createSelector } from "reselect";
import { RootState } from "store";

const selectSpace = (state: RootState) => state.space;

const selectIsChangeSpaceInProgress = createSelector(
  selectSpace,
  (substate) => substate.spaceChangeInProgress,
);

const selectCurrentSpaceId = createSelector(
  (state: RootState) => state.space,
  (substate) => substate.spaceId,
);

export { selectSpace, selectIsChangeSpaceInProgress, selectCurrentSpaceId };
